import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "./styles/styles.scss";
import { Login } from "./components/login";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Mashup from "./components/mashup";
import "react-toastify/dist/ReactToastify.css";
import { BaseName } from "./redux/Server";
// import { TimeoutProvider } from "./components/providers/timeoutProvider";

//Make the below TimeoutProvider to wrap Routes container inside BrowserRouter to apply session timeout
//<TimeoutProvider>
//</TimeoutProvider>

function App() {
  return (
    <BrowserRouter basename={BaseName}>
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route exact path="/mashup" element={<Mashup />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
